import React, {useLayoutEffect, useState} from 'react';
import AgeRestrictedContext from "../../../../services/Common/AgeRestrictedContext";
import PopupModal from "../../../../components/Modal/PopupModal";
import IframeWidget from "../../../../utils/IframeWidget";
import {ReactComponent as LockIco} from "../../../../../images/icons/lock.svg";
import {useTranslation, withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {RootState} from "../../../../../reducers";
import {getStoreConfig} from "../../../../services/Store/reducer";
import StoreUtils from "../../../../services/Store/StoreUtils";

interface OwnProps {
    externalShow?: boolean;
    externalOnHide?: () => void;
    zIndex?: number;
    onReject?: () => void;
    onConfirm?: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const AgeRestrictedModalComponent = ({externalShow, externalOnHide, zIndex, onConfirm, onReject, config}: Props) => {
    const [show, setShow] = useState(externalShow !== undefined ? externalShow : false);
    const {t} = useTranslation();

    useLayoutEffect(() => {
        if (externalShow !== undefined) return;

        if (AgeRestrictedContext.alreadyChecked()) return;

        const accepted = AgeRestrictedContext.isAccepted(StoreUtils.isAgeRestrictionDisabled(config));
        const alcohol = AgeRestrictedContext.isAlcohol();

        if (!accepted && alcohol) {
            setTimeout(() => {
                AgeRestrictedContext.setChecked(true);
                setShow(true);
            }, 100)
        }
    }, []);

    const onHide = () => {
        externalOnHide ? externalOnHide() : setShow(false);
    }

    const save = () => {
        AgeRestrictedContext.accept();
        onConfirm?.();
        IframeWidget.onHide(onHide);
    }

    const reject = () => {
        onReject?.();
        IframeWidget.onHide(onHide);
    }

    return (
        <PopupModal
            description={t("modules.menu.field.alcohol_advert.title")}
            title={t("modules.menu.field.age_confirmation.title")}
            show={show}
            style={{zIndex: zIndex}}
            onHide={onHide}
            onShow={() => {
            }}
            primaryButton={
                <button type="button" className="btn btn-primary w-100"
                        onClick={save}>
                    {t("modules.menu.action.confirm_age.title")}
                </button>
            }
            secondaryButton={
                <button type="button" className="btn btn-default w-100"
                        data-dismiss="modal" onClick={reject}>
                    {t("modules.menu.action.reject_age.title")}
                </button>
            }
            withoutCloseButton
            headerIcon={<LockIco/>}
            backdrop="static"
        />
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(AgeRestrictedModalComponent));